import type { IsEqual } from 'type-fest';
import { useUserActions } from '../../resource/resources/persistables/user/userResource';

type UseUserIdResult<F extends string = never> = IsEqual<F, never> extends true ? string | undefined : string | F;

export const useUserId = <F extends string = never>(fallback?: F): UseUserIdResult<F> => {
    const userActions = useUserActions();
    const userQuery = userActions.useGetResourceByToken();

    if (!userQuery.data) {
        return fallback as UseUserIdResult<F>;
    }

    return userQuery.data.id;
};
